import { configureStore } from '@reduxjs/toolkit'
import appStateReducer from './appStateSlice';
import tokenReducer from './tokenSlice';
import navigationReducer from './navigationSlice';
import { encryptTransform } from 'redux-persist-transform-encrypt';

import {
    persistStore,
    persistReducer
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const transform =  [
	encryptTransform({
	  secretKey: process.env.REACT_APP_PERSISTS_KEY ?? 'Gridline2023!@#',
	  onError: function (error) {
		// Handle the error.
	  },
	}),
]

const persistConfig = {
    key: 'token',
    version: 1.0,
    storage,
	transforms: transform,
};

const persistConfigNav = {
    key: 'nav',
    version: 1.0,
    storage,
	transforms: transform,
};



const persistTokenReducer = persistReducer(persistConfig, tokenReducer)
const persistNavigationReducer = persistReducer(persistConfigNav, navigationReducer)

const store = configureStore({
  reducer: {
	  appState:  appStateReducer,
	  token: persistTokenReducer,
	  nav: persistNavigationReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
     	serializableCheck: false
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch

const persistor = persistStore(store);

export { store, persistor };